var _templateObject = _taggedTemplateLiteralLoose(['\n  width: ', 'px;\n  height: ', 'px;\n\n  @media screen and (max-width: 1024px) {\n    width: ', 'px;\n    height: ', 'px;\n  }\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n\n  @media screen and (max-width: 1024px) {\n    width: ', 'px;\n    height: ', 'px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { withTheme } from 'styled-components';
import { wrapAssetPath } from '../../../../utils';
import logo from './logo.png';
import Constants from '../../../../themes/rml';
var LOGO_ALT = 'Rand Mutual Assurance Logo';
var Img = styled.img(_templateObject, Constants.ui.defaultLogoWidth, Constants.ui.defaultLogoHeight, Constants.ui.smallLogoWidth, Constants.ui.smallLogoHeight);

var Logo = function Logo(_ref) {
  var theme = _ref.theme,
      logoDomain = _ref.logoDomain,
      _ref$websiteDomain = _ref.websiteDomain,
      websiteDomain = _ref$websiteDomain === undefined ? Constants.domains.website : _ref$websiteDomain;
  return React.createElement('a', {
    href: logoDomain || websiteDomain
  }, React.createElement(Img, {
    src: wrapAssetPath(theme, logo),
    title: LOGO_ALT,
    alt: LOGO_ALT
  }));
};

export default withTheme(Logo);